<!-- eslint-disable vue/no-v-html -->
<template>
    <div class="card">
        <div class="card-header">
            <div class="card-header__icon-wrapper">
                <mdi-icon icon="mdiStar" class="card-header__icon" />
            </div>

            <div class="card-header__title">
                {{ t('home.widgets.shortcuts.title') }}
            </div>
        </div>

        <div class="shortcuts">
            <!-- Order Lenses -->
            <router-link
                :to="{ name: 'order-lenses', params: route.params }"
                class="shortcut"
            >
                <div
                    class="shortcut__title"
                    v-html="t('home.widgets.shortcuts.shortcut.order_lenses.label')"
                >
                </div>
            </router-link>

            <!-- Return Lenses -->
            <router-link
                :to="{ name: 'return-lenses', params: route.params }"
                class="shortcut"
            >
                <div
                    class="shortcut__title"
                    v-html="t('home.widgets.shortcuts.shortcut.return_lenses.label')"
                >
                </div>
            </router-link>

            <!-- Price List -->
            <router-link
                v-if="store.getters['account/can']('price-list:view')"
                :to="{ name: 'price-list', params: route.params }"
                class="shortcut"
            >
                <div
                    class="shortcut__title"
                    v-html="t('home.widgets.shortcuts.shortcut.price_list.label')"
                >
                </div>
            </router-link>

            <!-- My Account -->
            <router-link
                :to="{ name: 'my-account', params: route.params }"
                class="shortcut"
            >
                <div
                    class="shortcut__title"
                    v-html="t('my_account.page_title')"
                >
                </div>
            </router-link>
        </div>
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

const { t } = useI18n({ useScope: 'global' });
const store = useStore();
const route = useRoute();
</script>

<style scoped>
@reference "#main.css";

.card
{
    @apply min-h-[300px];
}

.shortcuts
{
    @apply w-full flex flex-wrap justify-evenly p-4;
}

.shortcut
{
    @apply w-full flex items-center border-primary-100 border rounded-md mb-4 px-4 py-2 text-sm text-primary-500 cursor-pointer;
}

.shortcut:hover
{
    @apply bg-primary-50;
}

.shortcut__title
{
    @apply text-center leading-relaxed;
}
</style>
